module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iivey"))).then(() => parcelRequire('d0iPb'));